import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1df9fa1e&class=full-height"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1df9fa1e&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1df9fa1e')) {
      api.createRecord('1df9fa1e', component.options)
    } else {
      api.reload('1df9fa1e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1df9fa1e&class=full-height", function () {
      api.rerender('1df9fa1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/toursCombine/articleItem/travelNews/index.vue"
export default component.exports